<template>
  <div class="d-inline-flex align-items-center flex-nowrap">
    <img :src="displayUrl" v-if="displayUrl" class="product-image" alt="" />
    <BaseIcon v-else name="no-image" class="product-image" />
    <ImageUpload
      v-if="editable !== false"
      :id="id"
      type="asset"
      :private="true"
      v-on:update="onUploaded"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import ImageUpload from "../../inputs/ImageUpload";
import tenant from "../../../modules/tenant";
const BaseIcon = defineAsyncComponent(() => import("../../icons/BaseIcon.vue"));
export default {
  name: "AssetImageUpload",
  components: { BaseIcon, ImageUpload },
  props: {
    id: Number,
    row: Object,
    editable: Boolean,
    modelValue: String,
  },
  computed: {
    mediaUrl() {
      return tenant.getAppMediaUrl();
    },
    displayUrl() {
      if (!this.modelValue) {
        return null;
      }
      if (this.modelValue.startsWith("http")) {
        return this.modelValue;
      }
      return this.mediaUrl + "/" + this.modelValue;
    },
  },
  emits: ["update:modelValue", "changeImage"],
  methods: {
    onUploaded(image) {
      this.$emit("update:modelValue", this.imageUrl(image));
      this.$emit("changeImage", image);
    },
    imageUrl(image) {
      if (image.url) {
        return image.url;
      }
      if (image.remote) {
        return image.path;
      }
      return image.path + "/262-" + image.name + ".webp";
    },
  },
};
</script>
